module.exports = __webpack_public_path__ + "img/bg-shippo-l-color.0900d165.svg";